<template>
    <v-card>
        <!--<v-card-title>Max upload file size is {{ fileMaxSize }}</v-card-title>
        <v-card-title>Max number of files is {{ fileMaxNumber }}</v-card-title>
        <v-card-title>Drag and Drop File Upload</v-card-title>
        <v-card-subtitle>Or click to select files</v-card-subtitle>-->
        <v-card-text>
            <div class="drop-zone"
                 @drop.prevent="handleDrop"
                 @dragover.prevent="handleDragOver"
                 @click="openFileDialog">
                <input ref="fileInput"
                       type="file"
                       multiple
                       :accept="dynamicAcceptedFileTypes"
                       style="display: none"
                       @change="handleFileSelect" />
                <v-icon>mdi-file-upload</v-icon>
                <div class="text-center">
                    <div>{{$t('DragOrClick')}}</div>
                    <div><b>{{$t('fileMaxSize')}}:</b> {{fileMaxSize}} MB</div>
                    <div><b>{{$t('fileMaxNumber')}}:</b> {{fileMaxNumber}}</div>
                    <div style="display: inline-flex;">
                        <div v-for="(type, index) in processedFileTypes" :key="index" class="file-type">
                            {{ type }}
                        </div>
                    </div>
                </div>
                <div v-if="files.length > 0" >
                    <v-list>
                        <v-list-item-group>
                            <v-list-item v-for="(file, index) in files"
                                         :key="index"
                                         two-line
                                         class="d-flex align-center">
                                <v-list-item-content>
                                    <v-list-item-title>{{ file.name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ formatSize(file.size) }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon v-if="successmessages[index] && successmessages[index].uploading">mdi-progress-upload</v-icon>
                                    <v-icon v-if="successmessages[index] && successmessages[index].uploaded && !successmessages[index].success">mdi-refresh</v-icon>
                                    <v-icon v-if="successmessages[index] && successmessages[index].uploaded && successmessages[index].success">mdi-check-circle</v-icon>
                                    <v-icon v-if="successmessages[index] && !successmessages[index].uploading && !successmessages[index].uploaded" @click="removeFile(index)">mdi-delete</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </div>
                <div v-if="sizeErrors.length" class="error-messages">
                    <v-alert type="error" v-for="(error, index) in sizeErrors" :key="index">
                        {{ error }}
                    </v-alert>
                </div>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="uploadFiles" v-if="!viewMode" :disabled="files.length === 0">{{$t('UploadFiles')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import SurveyService from '@/services/SurveyService.js'

    export default {
        props: {
            acceptedFileTypes: {
                type: String,
                default: '.pdf,.doc,.docx,.png,.jpg,.jpeg,.gif'
            }, 
            DynamicAcceptedFileTypes: {
                type: String,
                default: '.pdf,.doc,.docx,.png,.jpg,.jpeg,.gif'
            },
            questId: {
                type: Number,
                default: null
            },
            modelValue: {
                type: String,
                default: ''
            },
            viewMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                files: [],
                successmessages:[],
                uploadedIds: [],
                fileMaxSize: 2, // in MB
                fileMaxNumber: 10,
                sizeErrors: []
            }
        },
        watch: {
            modelValue(newVal) {
                const ids = newVal.split(',').map(id => id.trim())
            },
            acceptedFileTypes(newVal) {
                this.dynamicAcceptedFileTypes = newVal
            }
        },
        computed: {
            processedFileTypes() {
                const dataOptions = this.acceptedFileTypes.split('#')
                return dataOptions[0]
                    .split(',')
                    .map(type => type.replace(/^\./, ''))
            }
        },
        created() {
            this.dynamicAcceptedFileTypes = this.acceptedFileTypes.split('#')[0]
            this.updateFileSize()
        },
        methods: {
            updateFileSize() {
                const dataOptions = this.acceptedFileTypes.split('#')
                this.fileMaxSize = Number(dataOptions[1]) || 2
                this.fileMaxNumber = Number(dataOptions[2]) || 10
            },
            handleDrop(event) {
                const droppedFiles = Array.from(event.dataTransfer.files)
                this.addFiles(droppedFiles)
            },
            handleDragOver(event) {
                event.preventDefault()
            },
            openFileDialog() {
                this.$refs.fileInput.click()
            },
            handleFileSelect(event) {
                const selectedFiles = Array.from(event.target.files)
                this.addFiles(selectedFiles)
            },
            addFiles(newFiles) {
                this.sizeErrors = []

                const filteredFiles = newFiles.filter(file => {
                    if (this.isFileTypeAccepted(file) && file.size <= this.fileMaxSize * 1024 * 1024) {
                        return true
                    } else if (file.size > this.fileMaxSize * 1024 * 1024) {
                        this.sizeErrors.push(this.$t('File ') + ' ' + `${file.name}` + this.$t('Exceed') + `${this.fileMaxSize}` + ' MB ' + this.$t('sizeLimit'))
                        return false
                    }
                    return false
                })

                const remainingSlots = this.fileMaxNumber - this.files.length

                if (filteredFiles.length > remainingSlots) {
                    this.sizeErrors.push(this.$t('filesUpTo') + ` ${this.fileMaxNumber}` + ' ' + this.$t('files'))
                }

                const filesToAdd = filteredFiles.slice(0, remainingSlots)
                filesToAdd.map(e => {
                    this.successmessages.push({ uploaded: false, uploading: false, success: false })
                })
                if (filesToAdd.length) {
                    this.files = [...this.files, ...filesToAdd]
                } else {
                }
            },
            isFileTypeAccepted(file) {
                const acceptedTypes = this.acceptedFileTypes.split('#')[0].split(',').map(type => type.trim())
                return acceptedTypes.some(type => {
                    if (type.startsWith('.')) {
                        return file.name.endsWith(type)
                    }
                    return file.type === type
                })
            },
            removeFile(index) {
                this.files.splice(index, 1)
                this.successmessages.splice(index,1)
                this.$emit('update:modelValue', this.files.map(file => file.id).join(','))
            },
            toBase64(file) {
                return new Promise((resolve, reject) => {
                    if (!(file instanceof File)) {
                       reject(new Error('Provided object is not a File instance'))
                        return
                    }

                    const reader = new FileReader()
                    reader.onload = () => resolve(reader.result)
                    reader.onerror = error => reject(error)
                    reader.readAsDataURL(file)
                })
            },
            async uploadFiles() {
                if (this.files.length === 0) return
                for (const [index, file] of this.files.entries()) {
                    this.$set(this.successmessages, index, { uploading: true })
                    //this.$set(this.files, index, { ...file})
                    try {
                        const base64Data = await this.toBase64(file)
                        const fileArray = [base64Data]
                        const response = await SurveyService.uploadFiles(fileArray, this.questId)

                        this.uploadedIds.push(response[0])
                        this.$set(this.successmessages, index, { uploaded: true, success: true })
                        
                        //this.$set(this.files, index, { ...file, uploaded: true, success: true })
                    } catch (error) {
                        console.error('Upload failed', error)
                        this.$set(this.successmessages, index, { uploaded: true, success: false })
                        //this.$set(this.files, index, { ...file, uploaded: true, success: false })
                    }
                }
                this.$emit('input', this.uploadedIds.join(','))
            },
            formatSize(size) {
                if (size < 1024) return `${size} B`
                else if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`
                else return `${(size / 1048576).toFixed(2)} MB`
            }
        }
    }
</script>

<style scoped>
    .drop-zone {
        border: 2px dashed #cccccc;
        border-radius: 8px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
    }

        .drop-zone:hover {
            background-color: #f0f0f0;
        }

    .file-type {
        width: 50px;
        padding: 4px;
        margin: 5px 2px;
        border: 1px solid #0a716e;
        border-radius: 11px;
        font-weight: bold;
        font-size: 15px;
        color: #fff;
        background-color: #0a716e;
    }
</style>
